// extracted by mini-css-extract-plugin
export default {"charts":"AvailabilityCharts_charts__DHTZj","charts__item":"AvailabilityCharts_charts__item__83W25"};